import React from 'react'
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import BoxWithIcon from "../../atoms/ComponentBox/BoxWithIcon";
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectPermissions } from '../../redux/permissionsSlice';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const PreRegistration = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const permissions = useSelector(selectPermissions);
  const hasModulePermission = (moduleName) => {
    const modulePermission = permissions.find(
      permission => permission.ModuleName === moduleName
    );

    if (!modulePermission) return false;

    return (
      modulePermission.AddRec === "1" ||
      modulePermission.EditRec === "1" ||
      modulePermission.DeleteRec === "1" ||
      modulePermission.ViewRec === "1"
    );
  };
  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container sx={{
          width: "100%",
          maxWidth: "100%"
        }}>
          <Grid item xs={12}>
            <Grid container spacing={1}>
              {hasModulePermission("Enquiry") && (
                <BoxWithIcon
                  totalCount={10}
                  activeCount={10}
                  inactiveCount={0}
                  link={{ pathname: '/visitor-table' }}
                  permissions={permissions}
                  title="Visitor"
                />
              )}
              {hasModulePermission("Enquiry") && (
                <BoxWithIcon
                  totalCount={10}
                  activeCount={10}
                  inactiveCount={0}
                  link={{ pathname: '/enquirytable' }}
                  permissions={permissions}
                  title="Enquiry"
                />)}
              {hasModulePermission("Follow-Ups") && (
                <BoxWithIcon
                  totalCount={10}
                  activeCount={10}
                  inactiveCount={0}
                  link={{ pathname: '/TableFollowUp' }}
                  permissions={permissions}
                  title="Follow-Ups"
                />)}
              {hasModulePermission("Lead Transfer") && (
                <BoxWithIcon
                  totalCount={10}
                  activeCount={10}
                  inactiveCount={0}
                  link={{ pathname: '/leadtransfertable' }}
                  permissions={permissions}
                  title="Lead Transfer"
                />)}
              {hasModulePermission("Booking") && (
                <BoxWithIcon
                  totalCount={10}
                  activeCount={10}
                  inactiveCount={0}
                  link={{ pathname: '/bookingtable' }}
                  permissions={permissions}
                  title="Booking"
                />)}
              {hasModulePermission("Pre-Checkin") && (
                <BoxWithIcon
                  totalCount={10}
                  activeCount={10}
                  inactiveCount={0}
                  link={{ pathname: '/BookingConfirmTable' }}
                  permissions={permissions}
                  title="Pre-Checkin"
                />)}

              {hasModulePermission("Change Plan") && (
                <BoxWithIcon
                  totalCount={10}
                  activeCount={10}
                  inactiveCount={0}
                  link={{ pathname: '/enquiry/planchangetable' }}
                  permissions={permissions}
                  title="Change Plan"
                />)}

              {hasModulePermission("Check-In") && (
                <BoxWithIcon
                  totalCount={10}
                  activeCount={10}
                  inactiveCount={0}
                  link={{ pathname: '/enquiry/checkintable' }}
                  permissions={permissions}
                  title="Check-In"
                />
              )}

              {/* <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link={{ pathname: '/enquiry/CheckoutTable' }}
                permissions={permissions}
                title="Check-Out"
              /> */}
              {hasModulePermission("Payment Advice") && (
                <BoxWithIcon
                  totalCount={10}
                  activeCount={10}
                  inactiveCount={0}
                  link={{ pathname: '/advicegeneratetable' }}
                  permissions={permissions}
                  title="Payment Advice"
                />
              )}
              {hasModulePermission("Receipt Voucher") && (
                <BoxWithIcon
                  totalCount={10}
                  activeCount={10}
                  inactiveCount={0}
                  link={{ pathname: '/receipt-table' }}
                  permissions={permissions}
                  title="Receipt Voucher"
                />
              )}

              {hasModulePermission("Payment Voucher") && (
                <BoxWithIcon
                  totalCount={10}
                  activeCount={10}
                  inactiveCount={0}
                  link={{ pathname: '/refundtable' }}
                  permissions={permissions}
                  title="Payment Voucher"
                />
              )}
              {hasModulePermission("Plan Calculation") && (
                <BoxWithIcon
                  totalCount={10}
                  activeCount={10}
                  inactiveCount={0}
                  // link="/bookingtable" 
                  link={{ pathname: '/calculation' }}
                  permissions={permissions}
                  title="Plan Calculation"
                />)}

              {hasModulePermission("Transaction TopUp") && (
                <BoxWithIcon
                  totalCount={10}
                  activeCount={10}
                  inactiveCount={0}
                  link={{ pathname: '/trntopuptable' }}
                  permissions={permissions}
                  title="Transaction TopUp"
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default PreRegistration